exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.flex-center[data-v-dee456ae] {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(255,255,255, 0.8);\n    z-index: 1001;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    margin: 0;\n}\n", ""]);

// exports
